// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__kyQaH","placeHolderShimmer":"ReportFilter_placeHolderShimmer__KsWBX"};